var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105.809441, 105.001877)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105.809441, 105.001877)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105.809441, 105.001877)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105.809441, 105.001877)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105.809441, 105.001877)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105.809441, 105.001877)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105.809441, 105.001877)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105.809441, 105.001877)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105.809441, 105.001877)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105.809441, 105.001877)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105.809441, 105.001877)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105.809441, 105.001877)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105.809441, 105.001877)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105.809441, 105.001877)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105.809441, 105.001877)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 113.037758, 143.46225)"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 113.037758, 143.46225)"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 113.037758, 143.46225)"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 113.037758, 143.46225)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 113.037758, 143.46225)"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 113.037758, 143.46225)"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 113.037758, 143.46225)"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 113.037758, 143.46225)"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 113.037758, 143.46225)"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 113.037758, 143.46225)"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 113.037758, 143.46225)"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 113.037758, 143.46225)"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 113.037758, 143.46225)"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 113.037758, 143.46225)"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 113.037758, 143.46225)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 14.482 31.664 L 56.854 445.38 L 249.973 492.702 L 442.32 445.38 L 485.527 31.664 L 14.482 31.664 Z M 406.687 419.889 L 249.973 458.458 L 92.55 419.889 L 56.148 64.579 L 443.796 64.579 L 406.687 419.889 Z M 101.795 116.446 L 102.887 129.912 L 117.46 270.385 L 250.036 270.385 L 250.036 270.329 L 322.52 270.329 L 315.201 335.994 L 249.458 351.344 L 249.458 351.454 L 248.945 351.454 L 183.203 336.105 L 179.03 295.541 L 120.606 295.541 L 127.861 375.725 L 248.945 404.54 L 250.036 404.54 L 250.036 404.318 L 370.542 375.669 L 371.633 366.637 L 385.244 232.427 L 387.299 218.961 L 249.458 218.961 L 249.458 219.072 L 171.711 219.072 L 166.446 166.871 L 392.499 166.871 L 393.59 156.067 L 396.673 129.912 L 397.764 116.446 L 249.458 116.446 L 101.795 116.446 Z",
    style: {
      fill: "rgb(140, 140, 140)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.bf767ff4f7ce95f51bffd1a455ce8af0.svg";
export { ForwardRef as ReactComponent };